import React, { useEffect, useState, useMemo } from "react"; // Add useMemo import
import {
  Box,
  Grid,
  Typography,
  Modal,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import Tabs from "./children/Tabs";
import BusinessBoxForm from "./children/BusinessBoxForm";
import ProfileBox from "./children/ProfileBox";
import { useSelector } from "react-redux";
import { selectProfile } from "../../../redux/reducers/gallery";
import { colors } from "../../../utils";
import { ASSETS } from "../../../utils/config";
import { ReactComponent as LinkVaultIcon } from "@assets/images/LinkVault.svg";
import LinkVault from "./children/LinkVault";
import { getActiveSubscriptionData } from "../../../redux/selectors/subscriptionSelectors";

const tabsList = [
  {
    label: "Profile Details",
    value: "0",
  },
  {
    label: "LinkVault",
    value: "1",
    icon: LinkVaultIcon,
  },
];

const GallerySettings = ({
  open,
  onClose,
  tabIdx = "0",
  openDefault = true, // for edit //opens create new business box if no business box on gallery
  hideTabs = false,
  title = "Gallery Settings",
  isWheelBusinessBox = false,
  openLibrarySection = false, // Add this prop
}) => {
  const [selectedTab, setSelectedTab] = useState(tabIdx || "0");
  const [changesPending, setChangesPending] = useState(false);
  //save changes modal
  const [svChOpen, setSvChOpen] = useState(false);
  const profile = useSelector(selectProfile) ?? {};
  const { data: currentPlan, loading: currentPlanLoading } = useSelector(
    getActiveSubscriptionData
  );

  const showBusinessViewOnly = title === "Business Box";

  // Reset selected tab when the modal opens or tabIdx changes
  useEffect(() => {
    if (open) {
      setSelectedTab(tabIdx); // Reset to tabIdx when the modal is opened
    }
    setSvChOpen(false);
    setChangesPending(false);
  }, [open, tabIdx]); // Run when 'open' or 'tabIdx' changes

  // reset the modal triggers if tab changes
  useEffect(() => {
    setSvChOpen(false);
    setChangesPending(false);
  }, [selectedTab]);

  useEffect(() => {
    console.log(changesPending);
  }, [changesPending]);

  const userProfileInitialValues = {
    firstName: profile?.first_name || "",
    username: profile?.username || "",
    lastName: profile?.last_name || "",
    bio: profile?.bio || "",
    profile_image: profile?.profile_image || "",
    // showNumberOfWheels: profile?.show_wheel_number || false,
  };

  const linkVaultInitialValues = useMemo(() => {
    return {
      external_links: profile?.external_links?.length
        ? profile.external_links
        : [],
    };
  }, [profile?.external_links]);

  const closeModal = () => {
    if (!changesPending) {
      onClose(true);
      setSvChOpen(false);
    } else {
      setSvChOpen(true);
    }
  };

  return (
    <Modal
      open={open}
      onClose={(canClose) => onClose(canClose)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#FFFFFF",
          boxShadow: 24,
          //maxWidth: "80vw",
          width: "70vw",
          border: "1px solid #E1E1E1",
          borderRadius: "8px",
          maxHeight: "90vh", // Ensure it doesn't exceed the viewport height
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 3,
            backgroundColor: colors.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            {showBusinessViewOnly ? (
              <img src={ASSETS.segmentEditor.Business} />
            ) : (
              <SettingsRoundedIcon sx={{ color: "#323232" }} />
            )}
            <Typography
              sx={{
                color: "#0F0F0F",
                fontSize: "24px",
                fontWeight: "700",
                lineHeight: "20px",
                fontFamily: "DM Sans",
              }}
            >
              {title}
            </Typography>
          </Box>

          <IconButton>
            <CloseIcon
              onClick={closeModal}
              sx={{
                cursor: "pointer",
                color: "#323232",
              }}
            />
          </IconButton>
        </Box>

        <Divider sx={{ width: "100%", backgroundColor: "#BBBBBB" }} />

        <Grid
          spacing={0}
          sx={{
            padding: "20px 0px",
          }}
          container
        >
          {!hideTabs && (
            <Grid item xs={2}>
              <Tabs
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                tabList={tabsList}
              />
            </Grid>
          )}

          <Grid item xs={hideTabs ? 12 : 10}>
            {showBusinessViewOnly ? (
              <BusinessBoxForm
                svChOpen={svChOpen}
                svChOpenSetter={setSvChOpen}
                pendingChanges={changesPending}
                pendingChangesSetter={setChangesPending}
                onClose={(canClose) =>
                  canClose ? onClose(canClose) : setSvChOpen(true)
                }
                openDefault={openDefault}
                hideTabs={hideTabs}
                isWheelBusinessBox={isWheelBusinessBox}
                openLibrarySection={openLibrarySection} // Pass this prop
                currentPlan={currentPlan}
                currentPlanLoading={currentPlanLoading}
              />
            ) : (
              <>
                {selectedTab === "0" && (
                  <ProfileBox
                    svChOpen={svChOpen}
                    svChOpenSetter={setSvChOpen}
                    pendingChanges={changesPending}
                    pendingChangesSetter={setChangesPending}
                    onClose={(canClose) =>
                      canClose ? onClose(canClose) : setSvChOpen(true)
                    }
                    initialValues={userProfileInitialValues}
                  />
                )}

                {selectedTab === "1" && (
                  <LinkVault
                    onClose={onClose}
                    initialValues={linkVaultInitialValues}
                  />
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default GallerySettings;
